var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaimuGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2639_30327)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2639_30327",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 30,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3687 -0.36377H-0.368164V32.3635H28.3687V-0.36377Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2639_30327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8699 8.31738H1.84863V30.7432H25.8699V8.31738Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61006 3.97656H2.95801V7.95536H9.61006V3.97656Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3275 7.59375H7.02344V10.1257H20.3275V7.59375Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3921 3.61523H4.06641V6.8706H24.3921V3.61523Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9246 11.9019H22.249V13.9455H24.9246V11.9019Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.61 6.14697H24.3926V29.658H26.61V6.14697Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8051 -0.00195312H5.91406V6.50878H21.8051V-0.00195312Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9465 1.74121H17.9922V3.7342H21.9465V1.74121Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0877 24.2324H22.1748V30.0197H28.0877V24.2324Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3492 26.041H19.958V30.0198H27.3492V26.041Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0874 28.2109H18.1094V30.3812H28.0874V28.2109Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83525 1.74121H5.95117V3.73422H9.83525V1.74121Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68567 13.9561H1.59766V15.9997H3.68567V13.9561Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1318 5.78516H19.958V11.9342H25.1318V5.78516Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74779 11.9019H1.59766V13.96H5.74779V11.9019Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1181 7.81787H11.9414V9.87962H14.1181V7.81787Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39242 5.78516H1.47949V18.8066H7.39242V5.78516Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2488 11.9019H5.74805V14.7087H22.2488V11.9019Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2777 13.9561H3.6748V24.0621H24.2777V13.9561Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83716 16H1.59766V24.2397H3.83716V16Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2488 23.7583H3.58984V26.3119H22.2488V23.7583Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1017 26.0698H5.74805V28.2907H20.1017V26.0698Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1694 28.2041H7.7627V30.2839H18.1694V28.2041Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69755 24.2324H0.00195312V30.3814H3.69755V24.2324Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91376 26.4023H1.84863V30.3811H5.91376V26.4023Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76213 28.2109H2.21875V30.3812H7.76213V28.2109Z",
    fill: "#58B551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1746 -0.36377H5.91406V1.80647H22.1746V-0.36377Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4576 7.59375H26.2402V30.3813H28.4576V7.59375Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6094 30.0195H1.47949V32.1897H26.6094V30.0195Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84919 7.95557H-0.368164V30.3814H1.84919V7.95557Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69627 5.42334H1.10938V7.9553H3.69627V5.42334Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80566 3.61523H2.21875V6.14718H4.80566V3.61523Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95515 1.74121H3.90039V3.73422H5.95515V1.74121Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9816 1.74121H21.9453V3.73422H23.9816V1.74121Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5005 3.25342H23.2832V5.78536H25.5005V3.25342Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0352 5.75293H24.9287V7.81468H27.0352V5.75293Z",
    fill: "#419639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2623 7.59375H14.0449V10.1257H16.2623V7.59375Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8273 6.87061H7.39258V10.126H11.8273V6.87061Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3271 5.78516H7.39258V7.95541H20.3271V5.78516Z",
    fill: "#ABDC6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29479 15.8301H6.61328V16.615H8.29479V15.8301Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29479 15.7432H6.61328V15.8336H8.29479V15.7432Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60893 15.7432H6.52051V16.6149H6.60893V15.7432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38334 15.8301H8.29492V16.615H8.38334V15.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38334 15.7432H8.29492V15.83H8.38334V15.7432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60871 15.7432H6.5166V15.8336H6.60871V15.7432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.951 15.8335H9.26953V16.6184H10.951V15.8335Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.951 15.7432H9.26953V15.8336H10.951V15.7432Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26225 15.7466H9.17383V16.6183H9.26225V15.7466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0367 15.8335H10.9482V16.6076H11.0367V15.8335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.044 15.7432H10.9482V15.8336H11.044V15.7432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17735 16.6182H8.38281V17.4718H9.17735V16.6182Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8385 16.6182H11.0439V19.208H11.8385V16.6182Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51723 16.6182H5.72266V19.208H6.51723V16.6182Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9553 19.208H10.1533V20.0038H10.9553V19.208Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0689 20.0835H9.25586V20.8792H10.0689V20.0835Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 20.9443H8.37988V21.7546H9.18182V20.9443Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30194 20.0835H7.5V20.8792H8.30194V20.0835Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40741 19.208H6.60547V20.0038H7.40741V19.208Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60893 16.6182H6.52051V20.0833H6.60893V16.6182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.044 16.6182H10.9482V20.0833H11.044V16.6182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49981 20.0039H6.60547V20.0835H7.49981V20.0039Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30153 20.8794H7.40723V20.959H8.30153V20.8794Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2626 21.7544H8.30176V21.834H9.2626V21.7544Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0678 20.8794H9.21777V20.959H10.0678V20.8794Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37913 20.9443H8.30176V21.7546H8.37913V20.9443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2551 20.9189H9.17773V21.7545H9.2551V20.9189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1531 19.208H10.0684V20.9587H10.1531V19.208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37953 16.6182H6.60938V19.208H8.37953V16.6182Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17814 17.4756H8.37988V20.872H9.17814V17.4756Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0682 18.3511H9.17383V20.0837H10.0682V18.3511Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9479 18.3511H10.0684V19.2083H10.9479V18.3511Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4128 19.208H7.5V20.0038H8.4128V19.208Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0678 17.4756H9.26953V18.3509H10.0678V17.4756Z",
    fill: "#E24949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37953 20.0039H7.5V20.0835H8.37953V20.0039Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25856 20.0835H9.17383V20.9444H9.25856V20.0835Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 20.8721H8.37988V20.9517H9.18182V20.8721Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38281 20.0835H8.30176V20.9516H8.38281V20.0835Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26593 17.4756H9.17383V18.3907H9.26593V17.4756Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26593 16.6182H9.17383V17.4754H9.26593V16.6182Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0685 16.6182H9.2666V17.4754H10.0685V16.6182Z",
    fill: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9405 17.5659H10.1533V18.264H10.9405V17.5659Z",
    fill: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9479 16.6182H10.1533V17.4754H10.9479V16.6182Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1531 16.6182H10.0684V17.4718H10.1531V16.6182Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1531 17.4756H10.0684V18.3509H10.1531V17.4756Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9479 17.4756H10.1533V17.566H10.9479V17.4756Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9479 18.2642H10.1533V18.351H10.9479V18.2642Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49933 19.208H7.40723V20.0038H7.49933V19.208Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49933 20.0835H7.40723V20.8792H7.49933V20.0835Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9553 20.0039H10.1533V20.0835H10.9553V20.0039Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9921 15.8408H16.3105V16.6257H17.9921V15.8408Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9921 15.7505H16.3105V15.8409H17.9921V15.7505Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3052 15.7539H16.2168V16.6256H16.3052V15.7539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0796 15.8408H17.9912V16.6257H18.0796V15.8408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0796 15.7539H17.9912V15.8407H18.0796V15.7539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3089 15.7505H16.2168V15.8409H16.3089V15.7505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6483 15.8408H18.9668V16.6257H20.6483V15.8408Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6483 15.7505H18.9668V15.8409H20.6483V15.7505Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9634 15.7539H18.875V16.6256H18.9634V15.7539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7369 15.8408H20.6484V16.6149H20.7369V15.8408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7442 15.7505H20.6484V15.8409H20.7442V15.7505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8747 16.6255H18.0801V17.4791H18.8747V16.6255Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5397 16.6255H20.7451V19.2153H21.5397V16.6255Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2174 16.6255H15.4229V19.2153H16.2174V16.6255Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6555 19.2153H19.8535V20.0111H20.6555V19.2153Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7691 20.0908H18.9561V20.8866H19.7691V20.0908Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8781 20.9551H18.0762V21.7653H18.8781V20.9551Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0021 20.0908H17.2002V20.8866H18.0021V20.0908Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1076 19.2153H16.3057V20.0111H17.1076V19.2153Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3052 16.6255H16.2168V20.0907H16.3052V16.6255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7442 16.6255H20.6484V20.0907H20.7442V16.6255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 20.0146H16.3057V20.0942H17.2V20.0146Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0027 20.8867H17.1084V20.9663H18.0027V20.8867Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9638 21.7617H18.0029V21.8413H18.9638V21.7617Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7689 20.8867H18.9189V20.9663H19.7689V20.8867Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0803 20.9551H18.0029V21.7653H18.0803V20.9551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9553 20.9263H18.8779V21.7618H18.9553V20.9263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8543 19.2153H19.7695V20.966H19.8543V19.2153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0807 16.6255H16.3105V19.2153H18.0807V16.6255Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8744 17.4829H18.0762V20.8793H18.8744V17.4829Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7693 18.3584H18.875V20.091H19.7693V18.3584Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6491 18.3584H19.7695V19.2156H20.6491V18.3584Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.113 19.2153H17.2002V20.0111H18.113V19.2153Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.765 17.4829H18.9668V18.3582H19.765V17.4829Z",
    fill: "#E24949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0798 20.0146H17.2002V20.0942H18.0798V20.0146Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9597 20.0908H18.875V20.9517H18.9597V20.0908Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8781 20.8794H18.0762V20.959H18.8781V20.8794Z",
    fill: "#E75959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.084 20.0908H18.0029V20.9589H18.084V20.0908Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9671 17.4829H18.875V18.398H18.9671V17.4829Z",
    fill: "#E75858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9671 16.6255H18.875V17.4828H18.9671V16.6255Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7687 16.6255H18.9668V17.4828H19.7687V16.6255Z",
    fill: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 17.5732H19.8535V18.2714H20.6406V17.5732Z",
    fill: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6481 16.6255H19.8535V17.4828H20.6481V16.6255Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8543 16.6255H19.7695V17.4791H19.8543V16.6255Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8543 17.4829H19.7695V18.3582H19.8543V17.4829Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6481 17.4829H19.8535V17.5733H20.6481V17.4829Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6481 18.2715H19.8535V18.3583H20.6481V18.2715Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2005 19.2153H17.1084V20.0111H17.2005V19.2153Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2005 20.0908H17.1084V20.8866H17.2005V20.0908Z",
    fill: "#8B5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6555 20.0146H19.8535V20.0942H20.6555V20.0146Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4132 21.353H10.5078V23.0856H11.4132V21.353Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0668 22.2212H13.1836V23.0857H14.0668V22.2212Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6359 21.353H15.7305V23.0856H16.6359V21.353Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1833 23.0859H11.4131V23.9179H13.1833V23.0859Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7267 23.0859H14.0674V23.9179H15.7267V23.0859Z",
    fill: "#221E1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2639_30327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaimuGreen);
export default __webpack_public_path__ + "static/media/MaimuGreen.b8264291a533d80625311fb93123b2aa.svg";
export { ForwardRef as ReactComponent };